module.exports = __webpack_public_path__ + "static/img/2926_phase_function_Paper_Points.af165fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2926_phase_function_Paper_Points.png
// module id = ZlY3
// module chunks = 0